import React from "react";

import { IonList, IonItem, IonLabel, IonBadge } from "@ionic/react";

import { useHistory } from "react-router-dom";

import Page from "../../components/Page/Page";

import { useCars } from "../../hooks/useCars";

export const CarsPage: React.FC = () => {
  const { list } = useCars();
  const { push } = useHistory();

  return (
    <Page name="Veículos">
      <IonList>
        {list.map((car, index) => (
          <IonItem
            onClick={() => push(`/page/cars/${car.id}`)}
            button
            key={`car-${index}`}
          >
            <IonLabel>
              {car.board}-{car.number}
            </IonLabel>
            <IonBadge slot="end" color="medium">
              {car.max}
            </IonBadge>
          </IonItem>
        ))}
      </IonList>
    </Page>
  );
};
